import { OptionStateType } from '@kubit/web-ui-components/option/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
const commonDefaultTokens = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        cursor: 'pointer',
        background_color: FOUNDATIONS.color_neutral_bg_onsurface_200,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_150}`,
        gap: FOUNDATIONS.spacing_150,
        ...STATE_TOKENS.container,
    },
    labelIconContainer: {
        flex: 1,
        display: 'flex',
        flex_direction: 'row',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    label: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        ...STATE_TOKENS.label,
    },
    labelHightlighted: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        ...STATE_TOKENS.labelHightlighted,
    },
    icon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_neutral_icon_50,
        ...STATE_TOKENS.icon,
    },
});
export const buildInputSearchOptionStyles = (FOUNDATIONS) => {
    return {
        [OptionStateType.DEFAULT]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    border_radius: FOUNDATIONS.radius_200,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
        [OptionStateType.FILLING]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    border_radius: FOUNDATIONS.radius_200,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
        [OptionStateType.HOVER]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    border_radius: FOUNDATIONS.radius_200,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
        [OptionStateType.SELECTED]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                    border_radius: FOUNDATIONS.radius_200,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
        [OptionStateType.DISABLED]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                    border_radius: FOUNDATIONS.radius_200,
                },
                label: {
                    color: FOUNDATIONS.color_accent_disabled_font_100,
                },
                icon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
        [OptionStateType.SELECTED_HOVER]: {
            ...commonDefaultTokens(FOUNDATIONS, {
                container: {
                    background_color: FOUNDATIONS.color_accent_selected_bg_200,
                    border_radius: FOUNDATIONS.radius_200,
                },
                labelHightlighted: {
                    font_variant: TextVariantType.FONT_PARAGRAPH_250,
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_weight: FONT_WEIGHT.font_bold,
                },
            }),
        },
    };
};
//# sourceMappingURL=inputSearch.js.map